import {ToggleGroup} from '@esgi/ui/form-controls';
import {styled} from '@esgi/ui/theme';
import {toggleGroupContent, toggleGroupItem, toggleGroupRoot} from '../../index.styled';

export const ToggleGroupRoot = styled(ToggleGroup.Root, toggleGroupRoot);
export const ToggleGroupContent = styled(ToggleGroup.Content, toggleGroupContent);
export const ToggleGroupItem = styled(ToggleGroup.Item, toggleGroupItem);
